import axiosV2, { apiRequest } from '../../core/http/axios_api_v2';

//The users pages' server calls (UserEdit, UserPermissions, Profile).
//
//They used to be store actions - getUser / updateUser / getPermissions / updateUserPermissions of
//store/user.store.js - but the store stopped registering that module long ago (store.js keeps it
//commented out), so every one of those dispatches threw: the user edit page opened with empty
//fields and saved nothing, the permissions page never loaded, the profile never saved.

export function getUser(id) {
    return axiosV2.get('users/' + id).then(res => res.data);
}

//the server copies only name / phone / email / newPass from the body (and active, manager → user)
export function updateUser(user) {
    return axiosV2.put('users/' + user.id, user).then(res => res.data);
}

//{ role_permissions, user_permissions }
export function getPermissions(id) {
    return apiRequest('get', 'users/permissions/' + id);
}

export function updateUserPermissions(id, permissions) {
    return axiosV2.post('users/permissions/' + id + '/permissions', { permissions: permissions }).then(res => res.data);
}
